import AgrotechClassPartnerImage from './AgrotechClassPartnerImage'
import AgrotechClassPartnerSpecialization from './AgrotechClassPartnerSpecialization'
import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'

export interface AgrotechClassPartnerResponsiblePerson {
  email: string
}

export default class AgrotechClassPartner extends BaseModel {
  id: number | null = null
  slug: string = ''
  inn: string = ''
  name: string = ''
  'logo_url': string | null = null
  'site_url': string | null = null
  'short_description': string = ''
  images: AgrotechClassPartnerImage[] = []
  specializations: AgrotechClassPartnerSpecialization[] = []
  'responsible_persons': AgrotechClassPartnerResponsiblePerson[] = []
  'is_published': boolean = false
  status: string | null = null
  'status_slug': string | null = null
  'refuse_reason': string | null = null
  'updated_at': string | null = null
  'created_at': string | null = null

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.is_published = data.is_published === true || data.is_published === 1 || data.is_published === '1'

      this.images = Array.isArray(data.images) ? data.images.map(i => new AgrotechClassPartnerImage(i)) : []

      this.specializations = Array.isArray(data.specializations)
        ? data.specializations.map(i => new AgrotechClassPartnerSpecialization(i))
        : []

      this.responsible_persons = Array.isArray(data.responsible_persons)
        ? data.responsible_persons
            .filter(isUnknownObject)
            .map(i => ({ email: typeof i.email === 'string' ? i.email : '' }))
        : []
    }
  }

  get isNew(): boolean {
    return !this.id
  }

  get responsiblePersonEmail(): string {
    return this.responsible_persons[0]?.email ?? ''
  }
}
